import React from 'react'
import { withPrefix } from 'gatsby'
import Slider from 'react-slick'
import { ArrowRight } from '../../../svg/arrow_right'
import s from './benefits.module.css'

const Benefits = () => {
  const itemsColumnCarouselInfo = [
    {
      containerClassName: 'tw-pt-2@lg tw-pr-4@lg tw-pb-4@lg tw-pl-2@lg',
      containerImageClassName: 'bg-yellow-1 tw-pt-2',
      imageContent: {
        src: withPrefix('/images/couple-smartphone.svg'),
        alt: 'couple-smartphone',
      },
      titleItem: 'Beneficios Prima',
      DescriptionItem:
        'Un programa de beneficios exclusivos, con descuentos y promociones especiales en productos y servicios.',
      anchorTextHref: 'https://www.beneficiosprima.pe/BeneficiosPrimaWeb/',
    },
    {
      containerClassName: 'tw-pt-4@lg tw-pr-4@lg tw-pb-2@lg tw-pl-2@lg',
      containerImageClassName: 'bg-orange-4 tw-pt-2',
      imageContent: {
        src: withPrefix('/images/girl-laptop.svg'),
        alt: 'girl-laptop',
      },
      titleItem: 'Conferencias y podcasts',
      DescriptionItem:
        'Disfruta de conferencias en línea a cargo de expertos y resuelve tus dudas en nuestro podcast Micros Abiertos.',
      anchorTextHref: 'https://miespacio.prima.com.pe/',
    },
    {
      containerClassName: 'tw-pt-4@lg tw-pr-2@lg tw-pb-2@lg tw-pl-4@lg',
      containerImageClassName: 'bg-gray--13 tw-pt-2',
      imageContent: {
        src: withPrefix('/images/girl-piggy-bank2.svg'),
        alt: 'girl-piggy-bank2',
      },
      titleItem: 'AhorroYa!',
      DescriptionItem:
        'Creamos un espacio para dar a conocer los emprendimientos de nuestros afiliados y sus familiares.',
      anchorTextHref:
        'https://www.prima.com.pe/public-zone/aliados-comerciales/sobre-el-programa/',
    },
  ]

  const slickSettingsProductos = {
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 20000,
    margin: 0,
    rows: 2,
    initialSlide: 0,
    centerMode: true,
    infinite: false,
    centerPadding: 0,
    appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
    customPaging: i => <span className="ft-slick__dots--custom"></span>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          rows: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
          dots: true,
        },
      },
    ],
  }

  return (
    <div className={'containerWrap'}>
      <div className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg center m-auto tw-mb-6 tw-mb-6@lg">
        Nuestro propósito es guiarte y acompañarte
      </div>

      <h2 className="font-family-secondary fw-1 tw-f-20 tw-f-24@lg tw-mb-12 tw-mb-12@lg center c-gray--4 tw-mt-0">
        Estos son los beneficios que tenemos para tí
      </h2>

      <Slider {...slickSettingsProductos}>
        {itemsColumnCarouselInfo.map(element => (
          <div className={element.containerClassName} key={element.titleItem}>
            <div
              className={`${s.itemColumnCarousel} brad-4 shadow-3 overflow-hidden bg-white`}
            >
              <div className={element.containerImageClassName}>
                <img
                  src={element.imageContent.src}
                  alt={element.imageContent.alt}
                  className={`${s.itemColumnCarousel__image}`}
                />
              </div>

              <div className={`tw-p-8`}>
                <h3
                  className={`font-family-secondary fw-7 tw-f-20 tw-f-20@lg tw-m-0`}
                >
                  {element.titleItem}
                </h3>

                <div
                  className={`font-family-primary fw-4 tw-f-16 tw-f-16@lg tw-mb-6`}
                >
                  {element.DescriptionItem}
                </div>

                <div
                  className={`font-family-secondary fw-6 tw-f-16 tw-f-16@lg c-orange-2`}
                >
                  <a
                    href={element.anchorTextHref}
                    target="_blank"
                    className={`c-orange-2`}
                    aria-label={element.titleItem}
                  >
                    Quiero saber más{' '}
                    <ArrowRight
                      className={'tw-pt-1'}
                      width={16}
                      height={16}
                      fill={'#CA3F04'}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default Benefits
